import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PutHelloFormFields {

    public loginStyle: FormField

    constructor() {

        this.loginStyle = new FormField(
          'loginStyle',
          'Login style',
          null,
          FormFieldType.text,
          false,
        )

    }
}

const fields = new PutHelloFormFields()

export const putHelloFormFieldOptions: {[key: string]: FormField} = {
  loginStyle: fields.loginStyle,
};